import { motion } from "framer-motion";
import { Dumbbell, UserRoundCheck, Scale, Flame, Sparkles, HeartHandshake } from "lucide-react";
import { FEATURES } from "@/lib/gymData";

const ICONS = { Dumbbell, UserRoundCheck, Scale, Flame, Sparkles, HeartHandshake };

export const WhyChooseUs = () => {
  return (
    <section id="why" data-testid="why-section" className="relative bg-[#0d0d0d] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <p className="text-blaze text-xs uppercase tracking-[0.3em] mb-4">Why Choose Us</p>
          <h2 className="font-display text-white text-5xl sm:text-6xl xl:text-7xl leading-[0.9] tracking-tight">
            BUILT FOR RESULTS
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/10">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon];
            return (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                data-testid={`feature-${i}`}
                className="group border-r border-b border-white/10 p-8 sm:p-10 hover:bg-black/40 transition-colors"
              >
                <div className="w-12 h-12 flex items-center justify-center border border-white/15 text-blaze mb-6 group-hover:bg-blaze group-hover:text-white transition-colors">
                  <Icon size={22} />
                </div>
                <h3 className="font-display text-white text-2xl sm:text-3xl tracking-tight leading-none">
                  {f.title}
                </h3>
                <p className="mt-3 text-neutral-400 text-sm leading-relaxed tracking-wide">{f.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
